module.exports = __webpack_public_path__ + "img/gallery01.287e5d3c.png";